import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
/**
 * Inserts Telegram's official login widget. The widget posts back to our API
 * route which sets the session cookie and redirects to /app/me.
 */
export function TelegramLoginButton({ botUsername, redirectTo = '/api/auth/telegram/callback', size = 'large', }) {
    const containerRef = useRef(null);
    useEffect(() => {
        const container = containerRef.current;
        if (!container)
            return;
        container.innerHTML = '';
        const script = document.createElement('script');
        script.src = 'https://telegram.org/js/telegram-widget.js?22';
        script.async = true;
        script.setAttribute('data-telegram-login', botUsername);
        script.setAttribute('data-size', size);
        script.setAttribute('data-radius', '6');
        script.setAttribute('data-auth-url', `${window.location.origin}${redirectTo}`);
        script.setAttribute('data-request-access', 'write');
        container.appendChild(script);
    }, [botUsername, redirectTo, size]);
    return _jsx("div", { ref: containerRef });
}
